"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createError = void 0;
/** Helper to create an Error object */
function createError(reason, response, innerException) {
    const newError = new Error(reason);
    return Object.assign(newError, {
        reason,
        serverResponse: response,
        innerException,
    });
}
exports.createError = createError;
